import React from 'react';
import styled from 'styled-components';
import { NoTranslate } from '@shared/components/no-translate/no-translate';
import { FontStyle } from '../styles/FontStyle';

const defaultProps = {
    styles: {
        wrapper: {},
        image: {},
        label: {},
    },
    icon: null,
    shouldDisplayBackground: false,
    src: null,
    alt: null,
    label: null,
};

interface ImageWithLabelProps {
    src?: string;
    alt?: string;
    styles?: {
        image?: React.CSSProperties;
        wrapper?: React.CSSProperties;
        label?: React.CSSProperties;
    };
    icon?: React.ReactNode;
    label: string;
}

const ImageWithLabel = ({
    alt,
    label,
    icon,
    src,
    styles,
    ...rest
}: ImageWithLabelProps) => {
    const imageComponent = src ? <Image alt={alt} imageStyles={styles.image} src={src} /> : null;
    const image = icon || imageComponent;

    return (
        <Wrapper
            {...rest}
            styles={styles.wrapper}
        >
            {image}
            {label && (
                <NoTranslate>
                    <Label labelStyles={styles.label}>
                        {label}
                    </Label>
                </NoTranslate>
            )}
        </Wrapper>
    );
};

ImageWithLabel.defaultProps = defaultProps;

const Image = styled.img`
    height: 20px;
    width: 20px;
    margin-right: 5px;
    ${({ imageStyles }) => imageStyles && { ...imageStyles }};
`;

const Label = styled.div`
    ${FontStyle};
    ${({ labelStyles }) => labelStyles && { ...labelStyles }};
`;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    
    ${({ shouldDisplayBackground }) => shouldDisplayBackground && {
        'align-items': 'center',
        'background-color': '#F1F5F9',
        'border-radius': '30px',
        display: 'flex',
        height: '30px',
        'justify-content': 'center',
        padding: '0 15px',

        '@media (max-width: 480px)': {
            height: '35px',
        },

    }};
    
    ${({ styles }) => styles && { ...styles }};
`;

export default ImageWithLabel;
